/**
 * Applique le filtre historique sur un URLSearchParams.
 * Ne jamais envoyer include_historique et annee_universitaire ensemble.
 */
export function applyHistoriqueParams(
  params: URLSearchParams,
  options?: {
    includeHistorique?: boolean
    anneeUniversitaire?: string | null
  }
) {
  const annee = options?.anneeUniversitaire?.trim()
  if (annee) {
    params.set('annee_universitaire', annee)
    params.delete('include_historique')
    return
  }
  if (options?.includeHistorique) {
    params.set('include_historique', '1')
    params.delete('annee_universitaire')
  }
}

/**
 * Quand historique actif (année ou tout), ne pas forcer is_active=true
 * sinon les ressources clôturées restent invisibles.
 */
export function shouldSkipActiveFilter(options?: {
  includeHistorique?: boolean
  anneeUniversitaire?: string | null
}): boolean {
  return !!(options?.includeHistorique || options?.anneeUniversitaire?.trim())
}
